import de from './de-DE';
import en from './en-US';
import es from './es-ES';
import fi from './fi-FI';
import fr from './fr-FR';
import it from './it-IT';
import ja from './ja-JP';
import ko from './ko-KR';
import nl from './nl-NL';
import pl from './pl-PL';
import pt from './pt-PT';
import ru from './ru-RU';
import sv from './sv-SE';
import tr from './tr-TR';
import zh from './zh-CN';

export default {
  'de-DE': de,
  'en-US': en,
  'es-ES': es,
  'fi-FI': fi,
  'fr-FR': fr,
  'it-IT': it,
  'ja-JP': ja,
  'ko-KR': ko,
  'nl-NL': nl,
  'pl-PL': pl,
  'pt-PT': pt,
  'ru-RU': ru,
  'sv-SE': sv,
  'tr-TR': tr,
  'zh-CN': zh
};
